import { render, staticRenderFns } from "./shopOfflineSubsidy.vue?vue&type=template&id=82619f3a&scoped=true"
import script from "./shopOfflineSubsidy.vue?vue&type=script&lang=js"
export * from "./shopOfflineSubsidy.vue?vue&type=script&lang=js"
import style0 from "./shopOfflineSubsidy.vue?vue&type=style&index=0&id=82619f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82619f3a",
  null
  
)

export default component.exports